import styles from "./styles/SubmitOrganizationButton.module.scss";
import ClickableLink from "../../utilities/ClickableLink";

const SubmitOrganizationButton = (props: {
    text?: string,
    url: string,
}) => {
    return (
        <ClickableLink className={styles.link} href={props.url}>{props.text}</ClickableLink>
    );
};

export default SubmitOrganizationButton;
